import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'


import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"

import './theme/theme.scss';

import revealWords from './directives/revealWords.js'


createApp(App)
.use(store)
.use(router)
.directive("reveal-words", revealWords)
.mount('#app')


